module.exports = __webpack_public_path__ + "img/almenu_gomb_kutatasok_jelentes.62ae2f9c.png";